import React from "react";

import { IconProps } from "../../types/common";

const RemoveUserIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#E64040",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M7.93002 7.40715L7.93003 7.40715C8.01623 7.41852 8.10336 7.43001 8.19432 7.43001C9.66765 7.43001 10.861 6.23668 10.861 4.76335C10.861 3.29001 9.66765 2.09668 8.19432 2.09668C6.72098 2.09668 5.52765 3.29001 5.52765 4.76335C5.52765 4.8543 5.53914 4.94143 5.55051 5.02763L5.55051 5.02764C5.55414 5.05516 5.55776 5.08259 5.56098 5.11001L7.84765 7.39668C7.87508 7.39991 7.9025 7.40352 7.93002 7.40715ZM9.321 8.87001L13.1477 12.6967C13.3677 12.5833 13.5277 12.3633 13.5277 12.0967V11.43C13.5277 10.0033 11.1543 9.09668 9.321 8.87001ZM2.60766 4.04335C2.4831 3.91851 2.314 3.84835 2.13766 3.84835C1.96131 3.84835 1.79221 3.91851 1.66766 4.04335C1.40766 4.30335 1.40766 4.72335 1.66766 4.98335L3.86099 7.17668L4.11432 7.43001L5.78766 9.10334C4.32099 9.50334 2.86099 10.2967 2.86099 11.43V12.0967C2.86099 12.4633 3.16099 12.7633 3.52766 12.7633H9.44766L11.641 14.9567C11.901 15.2167 12.321 15.2167 12.581 14.9567C12.841 14.6967 12.841 14.2767 12.581 14.0167L2.60766 4.04335Z"
    />
  </svg>
);

export default RemoveUserIcon;
